import * as types from './actionTypes';  
import plannerUserAccountApi from '../api/plannerUserAccountApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCreatePlannerUserAcc(request) {
  return {
    type: types.CREATE_PLANNER_USER_ACCOUNT, 
    request
  };
}

export function doCreatePlannerUserAccRes(data) {  
  return {
    type: types.CREATE_PLANNER_USER_ACCOUNT_RES, 
    data
  };
}

export function createPlannerUserAcc(request) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      plannerUserAccountApi.doCreatePlannerUserAcc(request).then(data => {
        dispatch(doCreatePlannerUserAccRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}